/* Pipers & Co — "Cook with us" rail
   Fades the ingredients panel while the rail is scrolling, then swaps to
   the recipe in view once scrolling stops. Panels are pre-rendered by
   Liquid and matched to cards BY INDEX, so there is no fetch and nothing
   to keep in sync beyond loop order.

   Also wires the desktop prev/next arrows to scroll to the next/previous
   card and keeps their disabled state in sync with scroll position. Scrolls
   land on the card's own offsetLeft rather than scrollBy-ing a computed
   card width — scroll-snap-type: mandatory fights a relative scrollBy and
   snaps straight back before the animation finishes; scrolling to an actual
   snap-aligned element position does not have that problem. */
(function () {
    var SETTLE_MS = 170;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-cwu-block]').forEach(function (block) {
        var rail = block.querySelector('[data-cwu-rail]');
        if (!rail) return;

        var panel = block.querySelector('[data-cwu-panel]');
        var prevBtn = block.querySelector('[data-cwu-prev]');
        var nextBtn = block.querySelector('[data-cwu-next]');
        var cards = Array.prototype.filter.call(rail.children, function (el) {
            return el.classList.contains('cwu-card');
        });

        function cardStep() {
            var card = rail.firstElementChild;
            if (!card) return 0;
            var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
            return card.offsetWidth + gap;
        }

        function updateNavButtons() {
            if (!prevBtn && !nextBtn) return;
            var atStart = rail.scrollLeft <= 1;
            var atEnd = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 1;
            if (prevBtn) {
                prevBtn.disabled = atStart;
                prevBtn.setAttribute('aria-disabled', String(atStart));
            }
            if (nextBtn) {
                nextBtn.disabled = atEnd;
                nextBtn.setAttribute('aria-disabled', String(atEnd));
            }
        }

        function goToCard(direction) {
            if (!cards.length) return;
            var step = cardStep();
            var current = step ? Math.round(rail.scrollLeft / step) : 0;
            var target = Math.max(0, Math.min(cards.length - 1, current + direction));
            rail.scrollTo({ left: cards[target].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        }

        if (prevBtn) prevBtn.addEventListener('click', function () { goToCard(-1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { goToCard(1); });
        updateNavButtons();

        var panes = panel ? panel.querySelectorAll('.cwu-panel__inner') : [];
        var timer;

        function activeIndex() {
            var step = cardStep();
            if (!step) return 0;
            return Math.max(0, Math.min(panes.length - 1, Math.round(rail.scrollLeft / step)));
        }

        rail.addEventListener('scroll', function () {
            updateNavButtons();

            if (panes.length < 2) return;
            panel.classList.add('is-settling');
            clearTimeout(timer);
            timer = setTimeout(function () {
                var i = activeIndex();
                panes.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
                panel.classList.remove('is-settling');
            }, SETTLE_MS);
        }, { passive: true });
    });
})();
